(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAddNetworks(
    NetworkListPaging, NetworkListService, $timeout, toastr, $filter
     ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/addNetworks/addNetworks.template.html',
      link: function(scope) {

        scope.NetworkListPaging = new NetworkListPaging();
        scope.networkList = [];
        scope.noNetworkSelected = true;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        scope.searchString = '';
        scope.selectedNetworks = [];

        (function() {
          customKeyBinding = true;
          getFirstPage();
        })();

        function getFirstPage() {
          scope.NetworkListPaging.pagingCriteria.page = 0;
          scope.NetworkListPaging.pagingCriteria.hasSite = false;
          scope.loadingPage = true;
          scope.networkList = [];

          NetworkListService.getNetworkListPaged(scope.NetworkListPaging).then(function (response) {
            window.scrollTo(0,0);
            scope.totalPages = response.page.totalPages;
            scope.networkList = response.list;
            scope.loadingPage = false;
          }).catch(function(error){});
        }

        // ADD THROTTLE TO THIS
        scope.textSearch = function () {
          scope.NetworkListPaging.pagingCriteria.match = scope.searchString;
          getFirstPage();
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.NetworkListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.NetworkListPaging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPaged(scope.NetworkListPaging).then(function(response){
              if (response.list) {
                scope.networkList = scope.networkList.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.NetworkListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        // TODO ADD escape key close, and ctrl + s to save

        scope.toggleSelectItem = function (event, item) {
          event.stopPropagation()
          event.preventDefault()
          if (!item.options.isSelected) {
            item.options.isSelected = true
            scope.selectedNetworks.push(item);
          } else {
            item.options.isSelected = false
            scope.deselectItem(item);
          }

          if (scope.selectedNetworks.length < 1) {
            scope.noNetworkSelected = true;
          } else {
            scope.noNetworkSelected = false;
          }
        }

        scope.deselectItem =  function (item) {
          for (var i = 0; i < scope.selectedNetworks.length; i++) {
            if (item.info._links.self.href === scope.selectedNetworks[i].info._links.self.href) {
              scope.selectedNetworks.splice(i, 1);
            }
          }
        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.addItemsToSite = function () {
          scope.context.addNetworksToSite(scope.selectedNetworks).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.closePopup();
        }

      }
    };
  }

  pxAddNetworks.$inject = ['NetworkListPaging', 'NetworkListService', '$timeout', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxAddNetworks', pxAddNetworks);

})();
